import React from 'react';
import { Container, Heading } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { useSeo } from '../utils/seo';
export function NotFound() {
  useSeo({
    title: 'Página no encontrada | Rabemar Servicios Integrales',
    description: 'La página solicitada no existe o fue movida. Explore las soluciones operativas de Rabemar.',
    path: '/404'
  });
  return <section className="bg-white py-24 md:py-32" data-id="element-797" data-mp="1a4u4yeht2d0d">
      <Container data-id="element-798" data-mp="1a1y4aiekpa88">
        <p className="font-display text-sm font-bold tabular-nums text-accent-500" data-id="element-799" data-mp="1f35cgikmobff">404</p>
        <Heading as="h1" size="md" className="mt-4" data-id="element-800" data-mp="1f0so9noa14tx">
          Esta página no existe.
        </Heading>
        <p className="mt-5 max-w-xl text-lg leading-relaxed text-graphite-500" data-id="element-801" data-mp="1nvfpe7mwqv0d">
          Puede volver al inicio o ir directamente a las soluciones operativas de Rabemar.
        </p>
        <div className="mt-9 flex flex-wrap gap-3" data-id="element-802" data-mp="1ssfkxom4sfd8">
          <Button to="/" size="lg" withArrow trackingLocation="404" data-id="element-803" data-mp="1xstq8ywclb7k">
            Volver al inicio
          </Button>
          <Button to="/soluciones" variant="secondary" size="lg" trackingLocation="404" data-id="element-804" data-mp="1nwn5z76vzd6u">
            Ver soluciones
          </Button>
        </div>
      </Container>
    </section>;
}